<template>
  <div>
    <el-dialog
      :title="title"
      align="center"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body>
      <div :data="myData" class="my_data">
        <span>视频高度:{{ this.myData.height }}</span>
        <span>视频宽度:{{ this.myData.width }}</span>
        <span>视频时长:{{ this.myData.playTime + "s" }}</span>
      </div>
      <!-- <div class="media-box" id="media-box"></div> -->
      <div v-if="mediaUrl" style="width: 400px; heigth: 130px; background: red;margin-top:10px">
        <DPlayer
          ref="player"
          :video="{
            url: mediaUrl,
            type: type === 'mp4' ? '' : 'hls',
            pic: '',
          }"
          hotkey
          :autoplay="true"
          @playing="onPlayerPlay"
          @pause="onPlayerPause"
          @loadeddata="onPlayerLoadeddata"
          @error="onPlayerError"
          @ended="onPlayerEnded"
          @waiting="onPlayerWaiting"></DPlayer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DPlayer from '../VueDplayerHls/index'

export default {
  name: 'ShowVideo',
  components: {
    DPlayer
  },
  data() {
    return {
      dialogVisible: false,
      mediaUrl: '',
      title: '封面图查看',
      params: {},
      myData: {},
      type: undefined,
      domain: '/api/web/media/m3u8/' // 存放图片的域名
    }
  },
  computed: {
    token() {
      return this.$store.state.user.token
    }
  },

  methods: {
    // / 监听视频播放的回调函数
    onPlayerPlay() {},
    // / 监听暂停播放的回调函数
    onPlayerPause() {},
    // / 监听当前视频数据加载完成
    onPlayerLoadeddata() {},
    // / 监听当前视频数据加载失败
    onPlayerError() {},
    // / 监听当前视频数据加载ing
    onPlayerWaiting() {},
    // / 监听当前视频播放完成
    onPlayerEnded() {},
    handleClose() {
      if (this.player) {
        this.player.dispose()
      }
      this.dialogVisible = false
      this.mediaUrl = ''
    },
    open(url, data) {
      console.log(url);
      
      this.myData = { ...data }
      this.dialogVisible = true
      this.title = '视频查看'
      // this.mediaUrl = this.domain + (url.match(RegExp(/.m3u8/)) ? url : url + '.m3u8')
      if (url.indexOf('mp4') !== -1) {
        this.mediaUrl = this.$store.getters.getSystemConfig.mp4Url + url
        this.type = 'mp4'
      } else {
        this.mediaUrl = (url.startsWith('http') ? '' : this.domain) + (url.match(RegExp(/.m3u8/)) ? url : url + '.m3u8')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.my_data {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.media-box {
  width: 100%;
  height: 400px;
  text-align: center;
  overflow: hidden;
  img {
    height: 100%;
    max-width: 100%;
  }
  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}
</style>
